// Code values of the universal search (group ids, status and view codes, DOM
// ids, query strings). Never text a user reads; the literal guard skips
// *.codes.ts files by design (eslint.i18n.config.js).

export const GROUP = {
  cards: 'cards',
  commanders: 'commanders',
  decks: 'decks',
  rules: 'rules',
  pages: 'pages',
  actions: 'actions',
} as const
export type GroupId = (typeof GROUP)[keyof typeof GROUP]

export const STATUS = {
  idle: 'idle',
  loading: 'loading',
  ready: 'ready',
  error: 'error',
} as const
export type InstantStatus = (typeof STATUS)[keyof typeof STATUS]

// `external`: opened by openCardSheet from outside the search (a deck legality
// chip); Back closes the panel there, since no list led to it.
export const SHEET_FROM = { list: 'list', cardSearch: 'cardSearch', external: 'external' } as const
export type SheetFrom = (typeof SHEET_FROM)[keyof typeof SHEET_FROM]

export const CARD_SEARCH_ERROR = { rate: 'rate', generic: 'generic', auth: 'auth', filter: 'filter' } as const

export const LISTBOX_ID = 'cb-search-listbox'
export const optionId = (i: number): string => `cb-search-opt-${i}`
export const groupLabelId = (group: string): string => `cb-search-group-${group}`
export const SCROLL_NEAREST: ScrollIntoViewOptions = { block: 'nearest' }

export const ENGLISH = 'en'
export const COMMON_NS = 'common'
export const UNICODE_DECOMPOSE = 'NFKD'
export const UNICODE_COMPOSE = 'NFC'
// Latin combining accents (U+0300 to U+036F) only. Japanese dakuten are NOT
// folded: they change the word, and the API keeps them too (alias_key).
export const LATIN_MARKS = new RegExp('[' + String.fromCharCode(0x300) + '-' + String.fromCharCode(0x36f) + ']', 'g')

export const buildForCommander = (name: string): string => `/build?commander=${encodeURIComponent(name)}`
export const deckPath = (id: string): string => `/decks/${encodeURIComponent(id)}`
export const suggestPath = (query: string): string => `/search/suggest?${query}`
export const rulesSearchPath = (query: string): string => `/rules/search?${query}`
export const ruleKey = (kind: string, id: string): string => `rule:${kind}:${id}`
export const deckEditPath = (id: string): string => `/decks/${encodeURIComponent(id)}/edit`

// The card detail read's identity prefixes (useCardDetail): by oracle id or by name.
export const DETAIL_KEY_OID = 'oid:'
export const DETAIL_KEY_NAME = 'name:'
